/**
 * 將以分鐘儲存的時間長度轉為容易閱讀的繁體中文。
 * 小於一小時保留分鐘；一小時以上改用小時與剩餘分鐘。
 */
export function formatDurationMinutes(minutes: number): string {
  const totalMinutes = Number.isFinite(minutes) ? Math.max(0, Math.round(minutes)) : 0;
  if (totalMinutes < 60) return `${totalMinutes} 分鐘`;

  const hours = Math.floor(totalMinutes / 60);
  const remainingMinutes = totalMinutes % 60;
  return remainingMinutes === 0
    ? `${hours} 小時`
    : `${hours} 小時 ${remainingMinutes} 分鐘`;
}
